export default class FuzzySearch {
	constructor(
		containerSelector,
		elementsSelector,
		resetButtonSelector,
		searchInputSelector,
		subElementConfig = {},
		postMatchCallback = null,
		postResetCallback = null,
		preSearchCallback = null,
	) {
		this.$container = $(containerSelector);
		this.$elements = this.$container.find(elementsSelector);
		this.$resetSearchButton = this.$container.find(resetButtonSelector);
		this.subElementConfig = subElementConfig;
		this.postMatchCallback = postMatchCallback;
		this.postResetCallback = postResetCallback;
		this.preSearchCallback = preSearchCallback;
		this.$searchInput = this.$container.find(searchInputSelector);

		// pp.log("FuzzySearch:: target elements", this.$elements);
		// pp.log("FuzzySearch:: reset search button", this.$resetSearchButton);
		// pp.log("FuzzySearch:: subElementConfig", this.subElementConfig)

		this.$resetSearchButton.on("click", this.resetSearch.bind(this));
		this.$searchInput.on("keyup", this.debounce(this.search.bind(this), 300));
	}

	search(e) {
		this.preSearchCallback(this.$container);
		const $searchInput = $(e.target).val();
		this.$resetSearchButton.removeClass("hidden");
		this.$elements.removeClass("FuzzySearch--match");

		if ($searchInput === "") {
			this.resetSearch();
			return;
		}

		const $matchingElements = this.searchElements($searchInput);

		if (this.postMatchCallback) {
			$matchingElements.each((idx, el) => {
				this.postMatchCallback($(el));
			});
		}
	}

	resetSearch(e) {
		// pp.log("FuzzySearch:: Reset search");
		// Logic to reset the search state
		this.$searchInput.val("");
		this.$resetSearchButton.addClass("hidden");
		this.$elements.removeClass("hidden FuzzySearch--match");
		if (this.postMatchCallback) {
			this.postResetCallback(this.$container);
		}
	}

	searchElements($searchInput) {
		this.$elements.addClass("hidden");

		const $matchingElements = this.$elements.filter((idx, el) => {
			const elementValues = this.getElementValues($(el));
			return Object.values(elementValues).some((val) => {
				return this.fuzzyMatch(val, $searchInput);
			});
		});

		$matchingElements.removeClass("hidden");
		$matchingElements.addClass("FuzzySearch--match");
		return $matchingElements;
	}

	getElementValues($element) {
		// pp.log("FuzzySearch:: inspecting Element", $element);
		const values = {};
		Object.keys(this.subElementConfig).forEach((selector) => {
			// pp.log("FuzzySearch:: searching selector", selector);
			this.subElementConfig[selector].forEach((attr) => {
				let target = $element.find(selector);
				// pp.log("FuzzySearch:: searching target", target);
				if (attr === "text") {
					values[`${selector}-${attr}`] = target.text();
				} else if (attr === "val") {
					values[`${selector}-${attr}`] = target.val();
				} else {
					values[`${selector}-${attr}`] = target.attr(attr);
				}
			});
		});
		// pp.log("FuzzySearch:: searching selector values", values);
		return values;
	}

	fuzzyMatch(input, search) {
		if (!input || !search) {
			return false;
		}
		input = input.toLowerCase();
		search = search.toLowerCase();
		return input.includes(search);
	}

	debounce(func, wait) {
		let timeout;
		return function () {
			// @ts-expect-error
			const context = this;
			const args = arguments;
			const later = function () {
				timeout = null;
				func.apply(context, args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}
}
